import * as Schema from "effect/Schema";

import { AmoregProjectFile, T3_PROJECT_FILE_SCHEMA_URL } from "@amoreg/contracts";

import { fromLenientJson } from "./schemaJson.ts";

/**
 * Codec between the raw `amoreg.json` file contents (lenient JSONC string) and the
 * decoded {@link AmoregProjectFile}.
 */
export const AmoregProjectFileFromJson = fromLenientJson(AmoregProjectFile);

/**
 * Build the publishable JSON Schema document for `amoreg.json` (draft 2020-12).
 *
 * Served from the marketing site at {@link T3_PROJECT_FILE_SCHEMA_URL} so
 * editors get LSP support via a `$schema` reference.
 */
export function buildT3ProjectFileJsonSchema(): Record<string, unknown> {
  const document = Schema.toJsonSchemaDocument(AmoregProjectFile);
  const jsonSchema: Record<string, unknown> = {
    $schema: "https://json-schema.org/draft/2020-12/schema",
    $id: T3_PROJECT_FILE_SCHEMA_URL,
    ...document.schema,
  };
  if (document.definitions && Object.keys(document.definitions).length > 0) {
    jsonSchema.$defs = document.definitions;
  }
  return jsonSchema;
}
